import deductibleTrackerResource from "@/shared/resource/deductibleTracker";
import { authorizedAxios } from "./authorizedAxios";
import {
  TalonEnabledResponse
} from "@/shared/types";

export function getIframeUrl () {
  return authorizedAxios.get(deductibleTrackerResource.getGenerateMymedicalshopperUrl());
}
export function getTalonEnabledForUser () {
  return authorizedAxios.get<TalonEnabledResponse>(deductibleTrackerResource.getTalonEnabledForUser());
}
export function isTalonEnabledForUser (userName: string) {
  return authorizedAxios.get<TalonEnabledResponse>(deductibleTrackerResource.isTalonEnabledForUser(userName));
}
export function getHealthPlanIsLinked () {
  return authorizedAxios.get(deductibleTrackerResource.getHealthPlanIsLinked());
}

export function getHealthPlans () {
  return authorizedAxios.get(deductibleTrackerResource.getHealthPlans());
}